// extracted by mini-css-extract-plugin
export var deliveryRow = "_r4-a";
export var fixedHeight = "_r4-4";
export var freightLogo = "_r4-9";
export var fullWidth = "_r4-3";
export var priceColumn = "_r4-5";
export var radioSelected = "_r4-7";
export var radioUnselected = "_r4-6";
export var selectedOption = "_r4-2";
export var selectedOptionContainer = "_r4-1";
export var selection = "_r4-0";
export var tallSkeletonText = "_r4-8";